module.exports = __webpack_public_path__ + "img/blank2.66a2eeee.svg";